// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardTotalIncome {
  background-color: #5260FF;
  color: white;
}

.datePicker {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3%;
}

ion-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/dashboards/dashboard-finance/dashboard-finance.component.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,YAAA;AADF;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAAJ;;AAGE;EACE,uBAAA;EACA,mBAAA;EACA,iFAAA;AAAJ","sourcesContent":["\r\n\r\n.cardTotalIncome{\r\n  background-color: #5260FF;\r\n  color: white;\r\n}\r\n.datePicker{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 3%;\r\n  }\r\n\r\n  ion-card{\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow:  0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
